/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EDocumentSelectFilter } from "../types/EDocumentSelectFilter.ts";

/**
 * @description 0 = All | 1 = WithDocuments | 2 = WithoutDocuments |
 */
export const eDocumentSelectFilterSchema = z
  .union([z.literal(0), z.literal(1), z.literal(2)])
  .describe(
    "0 = All | 1 = WithDocuments | 2 = WithoutDocuments | ",
  ) as unknown as ToZod<EDocumentSelectFilter>;
